export const MAIN_CLASS_NAME = 'ib-scroll-spy';

export const NAV_CLASS_NAME = `${MAIN_CLASS_NAME}__nav`;
export const LIST_CLASS_NAME = `${NAV_CLASS_NAME}__list`;
export const ITEM_CLASS_NAME = `${LIST_CLASS_NAME}__item`;
export const ACTIVE_ITEM_CLASS_NAME = `${ITEM_CLASS_NAME}_active`;

export const SECTIONS_CLASS_NAME = `${MAIN_CLASS_NAME}__sections`;
export const SECTION_CLASS_NAME = `${SECTIONS_CLASS_NAME}__section`;

export const SCROLL_ANIMATION_DURATION_MS = 400;
export const SCROLL_THROTTLE_MS = 100;

export const NAV_POSITION_DEFAULT = 'left';
export const DISPLAY_NAV_DEFAULT = true;
